/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { CustomerSubscriptionData_CustomerFragmentDoc } from './CustomersGridItem.graphql';
export type CustomerSwitcher_OrganizationFragment = { __typename: 'Organization', handle: string, name: string, avatarUrl?: string | null, customers: Array<{ __typename: 'Customer', id: string, name: string, handle: string, avatarUrl?: string | null, displayCount: number, waveSubscriptionUsage?: number | null, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null }> };

export type CustomerSwitcher_CustomerFragment = { __typename: 'Customer', id: string, name: string, handle: string, avatarUrl?: string | null, displayCount: number, waveSubscriptionUsage?: number | null, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null };

export const CustomerSwitcher_CustomerFragmentDoc = gql`
    fragment CustomerSwitcher_customer on Customer {
  id
  name
  handle
  avatarUrl
  waveSubscription {
    id
  }
  displayCount
  ...CustomerSubscriptionData_customer
}
    ${CustomerSubscriptionData_CustomerFragmentDoc}`;
export const CustomerSwitcher_OrganizationFragmentDoc = gql`
    fragment CustomerSwitcher_organization on Organization {
  handle
  name
  customers {
    id
    ...CustomerSwitcher_customer
  }
  avatarUrl
}
    ${CustomerSwitcher_CustomerFragmentDoc}`;